import { Component, ViewChild } from '@angular/core';
import { AnalyticEvents } from '@app/enums';
import { AnalyticService, NotificationService, NotifyService } from '@app/services';
import { AuthService } from '@app/services/auth.service';
import { ArchivedNotificationViewerComponent } from '../../components/archived-notification-viewer.component';

@Component({
    styleUrls: ['./archived-notifications.style.scss'],
    templateUrl: './archived-notifications.view.template.html',
})
export class ArchivedNotificationView {
    @ViewChild('archivedNotificationViewer', { static: false })
    archivedNotificationViewer: ArchivedNotificationViewerComponent;
    isLoading = false;
    totalNumberOfUnreadArchivedNotifications = 0;

    constructor(
        public auth: AuthService,
        public notificationService: NotificationService,
        public analyticService: AnalyticService,
        protected notify: NotifyService
    ) {
        this.getUnreadArchivedNotificationsCount();
    }

    getUnreadArchivedNotificationsCount(): void {
        this.notificationService.getUnreadArchivedNotificationsCount().then(() => {
            this.totalNumberOfUnreadArchivedNotifications =
                this.notificationService.totalNumberOfUnreadArchivedNotifications;
        });
    }

    onMarkAllAsRead(): void {
        this.analyticService.trackEvent(AnalyticEvents.NotificationsMarkAllArchivedRead);
        this.notificationService
            .markAllAsRead(true)
            .then(() => {
                this.archivedNotificationViewer.reloadCurrentNotifications();
            })
            .catch(() => {
                this.notify.error('archived-notifications.unableMarkAll');
            });
    }

    onMoveAllToInbox(): void {
        this.analyticService.trackEvent(AnalyticEvents.NotificationsMarkAllUnarchived);
        this.notificationService
            .unarchiveAll()
            .then(() => {
                this.archivedNotificationViewer.reloadCurrentNotifications();
            })
            .catch(() => this.notify.error('archived-notifications.unableMoveAll'));
        return;
    }
}
